import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] py-12 px-6 border-t border-gold/20" data-id="element-15">
      <div className="max-w-5xl mx-auto text-center" data-id="element-16">
        <p className="text-xs md:text-sm text-gray-500 mb-8 leading-relaxed max-w-4xl mx-auto" data-id="element-17">
          These statements have not been evaluated by the FDA. This product is
          not intended to diagnose, treat, cure, or prevent any disease. Consult
          your physician before starting any new health protocol. Individual
          results may vary.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gold/70 mb-8" data-id="element-18">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-19">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-20">
            Terms of Service
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-21">
            Contact
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-22">
            Refund Policy
          </a>
        </div>

        <p className="text-xs text-gray-600" data-id="element-23">
          &copy; {new Date().getFullYear()} The Master Code. All rights
          reserved.
        </p>
      </div>
    </footer>;
}